module.exports = __webpack_public_path__ + "img/Qpica.9026849b.png";